var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _c(
                    "fieldset",
                    [
                      _c("legend", { staticClass: "sr-only" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("common.global_config.parameters") ||
                              "Paramètres de configuration"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "form-card-wrapper",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "common.global_config.parameter_GDR"
                                    ),
                                    controlId: "global-config-gdr-checkbox",
                                    statusText:
                                      _vm.listItemsGlobalConfig.length > 0 &&
                                      _vm.listItemsGlobalConfig[0].Value == 1
                                        ? _vm.$t(
                                            "common.global_config.value_non_missing"
                                          )
                                        : _vm.$t(
                                            "common.global_config.value_missing"
                                          ),
                                    hasControl: true,
                                  },
                                },
                                [
                                  _c("template", { slot: "control" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.Value,
                                          expression: "Value",
                                        },
                                      ],
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "global-config-gdr-checkbox",
                                      },
                                      domProps: {
                                        checked:
                                          _vm.listItemsGlobalConfig.length >
                                            0 &&
                                          _vm.listItemsGlobalConfig[0].Value ==
                                            1,
                                        checked: Array.isArray(_vm.Value)
                                          ? _vm._i(_vm.Value, null) > -1
                                          : _vm.Value,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.Value,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.Value = $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.Value = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.Value = $$c
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.cncl"),
                  variant: "secondary",
                  outline: true,
                  size: "md",
                  "custom-class": "mr-3",
                  "aria-label":
                    _vm.$t("common.cncl") +
                    " " +
                    _vm.$t("Webheader.global_config"),
                },
                on: {
                  click: function ($event) {
                    return _vm.switchMode("details")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "success",
                  size: "md",
                  "aria-label":
                    _vm.$t("common.sve") +
                    " " +
                    _vm.$t("Webheader.global_config"),
                },
                on: { click: _vm.editGlobalConfig },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.formType === "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "success",
                  size: "md",
                  "aria-label":
                    _vm.$t("common.sve") +
                    " " +
                    _vm.$t("Webheader.global_config"),
                },
                on: { click: _vm.addGlobalConfig },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }